import {
  TbBrandDiscord,
  TbBrandFacebook,
  TbBrandInstagram,
  TbBrandLinkedin,
  TbBrandReddit,
  TbBrandSlack,
  TbBrandTiktok,
  TbBrandYoutube,
} from "solid-icons/tb";
import { For } from "solid-js";

export const ChatHomepagePlatformDropdown = () => {
  const data = [
    {
      column_title: "EXPLORE",
      column_description: "Turn unstructured data into clarity",
      links: [
        {
          text: "Turn Data Chaos to Action",
          description: "Go from cross-source data to decisive action.",
          href: "https://web.storytell.ai/every-file-meaningful-insights",
        },
        {
          text: "Get Better Answers",
          description: "Refine prompts, ask follow-ups and dig deeper all in one-click",
          href: "https://web.storytell.ai/get-better-answers",
        },
        {
          text: "Concepts",
          description: "Dynamically organize unstructured data into reusable Concepts",
          href: "https://web.storytell.ai/concepts",
        },
        {
          text: "Trust but Verify",
          description: "Validate every answer with sources and evidence",
          href: "https://web.storytell.ai/trust-but-verify",
        },
      ],
    },
    {
      column_title: "ACT",
      column_description: "Turn insight into action—fast",
      links: [
        {
          text: "Dynamic LLM Router",
          description: "Get the perfect answer, every time",
          href: "https://web.storytell.ai/llm-router",
        },
        {
          text: "Actions (Coming Soon)",
          description: "Automate next steps from live insights—alerts, actions, follow-ups.",
          href: "https://web.storytell.ai/actions",
        },
        {
          text: "Personalized AI (Coming Soon)",
          description: "Tailor Storytell to work like a teammate.",
          href: "https://web.storytell.ai/personalized-ai",
        },
      ],
    },
    {
      column_title: "COLLABORATE",
      column_description: "Work smarter together with shared intelligence",
      links: [
        {
          text: "Projects (Coming Soon)",
          description: "De-Silo teams by connecting files, chats and context across the org",
          href: "https://web.storytell.ai/de-silo-teams",
        },
      ],
    },
    {
      column_title: "SECURITY & CONTROL",
      column_description: "Control how Storytell works for your org",
      links: [
        {
          text: "Trust & Security",
          description: "Stay compliant with enterprise-grade governance",
          href: "https://web.storytell.ai/trust-and-security",
        },
        {
          text: "Cost Management",
          description: "Track & optimize AI usage by team & use case",
          href: "https://web.storytell.ai/manage-costs",
        },
        {
          text: "Enterprise Controls (Coming Soon)",
          description: "Manage teams, access levels, and data flow",
          href: "https://web.storytell.ai/enterprise-controls",
        },
      ],
    },
    {
      column_title: "RESOURCES",
      column_description: "Guides, prompts, events & tools to build with Storytell",
      links: [
        {
          text: "Why Storytell",
          description: "Weigh buying a platform vs in‑house enterprise AI",
          href: "https://web.storytell.ai/buy-vs-build-enterprise-ai",
        },
        {
          text: "Documentation",
          description: "Get started with Storytell’s developer docs",
          href: "https://help.storytell.ai",
        },
        {
          text: "AI Prompt Library",
          description: "Curated prompts to get better results from Storytell",
          href: "https://web.storytell.ai/prompts",
        },
      ],
    },
  ];
  return (
    <div class="w-full max-w-6xl">
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 py-3 px-3 sm:gap-4 sm:py-4 sm:px-4">
        <For each={data}>
          {(col) => (
            <div class="flex flex-col gap-1 sm:gap-2">
              <div class="p-1 sm:p-2">
                <h3 class="font-medium text-sm mb-1 bg-gradient-to-r from-violet-500 to-blue-500 dark:from-violet-400 dark:to-blue-400 text-transparent bg-clip-text">
                  {col.column_title}
                </h3>
                <p class="text-xs text-muted-text">{col.column_description}</p>
              </div>
              <For each={col.links}>
                {(link) => (
                  <a
                    href={link.href}
                    target="_blank"
                    class="hover:text-violet-400 dark:hover:text-violet-400 hover:bg-panel-hover p-1 sm:p-2 rounded-lg"
                    rel="noreferrer"
                  >
                    <p class="font-medium">{link.text}</p>
                    <p class="text-xs text-muted-text">{link.description}</p>
                  </a>
                )}
              </For>
            </div>
          )}
        </For>
      </div>
      <div class="px-3 pb-3 sm:px-4 sm:pb-4">
        {/* Mobile: 2 rows, Desktop: 1 row */}
        <div class="block sm:hidden">
          <div class="flex items-center gap-1 text-xs text-muted-text mb-1">
            <span class="font-bold bg-gradient-to-r from-violet-500 to-blue-500 dark:from-violet-400 dark:to-blue-400 text-transparent bg-clip-text">
              Connect with us:
            </span>
            <a
              href="https://web.storytell.ai/blog"
              target="_blank"
              rel="noreferrer"
              class="hover:text-violet-400 dark:hover:text-violet-400"
            >
              Our Blog
            </a>
            <span>|</span>
            <a
              href="https://join.slack.com/t/storytell-playground/shared_invite/zt-26x26fkmf-YCM4rn8_qRRqChsqhDL2Gg"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <TbBrandSlack class="w-3 h-3" />
              Slack
            </a>
            <span>|</span>
            <a
              href="https://discord.gg/3vmkttmddy"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <TbBrandDiscord class="w-3 h-3" />
              Discord
            </a>
            <span>|</span>
            <a
              href="https://www.linkedin.com/company/storytell-ai"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <TbBrandLinkedin class="w-3 h-3" />
              LinkedIn
            </a>
          </div>
          <div class="flex items-center gap-1 text-xs text-muted-text">
            <a
              href="https://x.com/storytell_ai"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <svg class="w-3 h-3" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <span>|</span>
            <a
              href="https://www.reddit.com/r/Storytell_ai/"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <TbBrandReddit class="w-3 h-3" />
              Reddit
            </a>
            <span>|</span>
            <a
              href="https://www.youtube.com/@storytell_ai"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <TbBrandYoutube class="w-3 h-3" />
              Youtube
            </a>
            <span>|</span>
            <a
              href="https://www.instagram.com/storytell_ai"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <TbBrandInstagram class="w-3 h-3" />
              Instagram
            </a>
            <span>|</span>
            <a
              href="https://www.facebook.com/storytellai"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <TbBrandFacebook class="w-3 h-3" />
              Facebook
            </a>
            <span>|</span>
            <a
              href="https://tiktok.com/@storytell.ai"
              target="_blank"
              rel="noreferrer"
              class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
            >
              <TbBrandTiktok class="w-3 h-3" />
              TikTok
            </a>
          </div>
        </div>

        {/* Desktop: Single row */}
        <div class="hidden sm:flex sm:items-center gap-2 text-xs text-muted-text">
          <span class="font-bold bg-gradient-to-r from-violet-500 to-blue-500 dark:from-violet-400 dark:to-blue-400 text-transparent bg-clip-text">
            Connect with us:
          </span>
          <a
            href="https://web.storytell.ai/blog"
            target="_blank"
            rel="noreferrer"
            class="hover:text-violet-400 dark:hover:text-violet-400"
          >
            Our Blog
          </a>
          <span>|</span>
          <a
            href="https://join.slack.com/t/storytell-playground/shared_invite/zt-26x26fkmf-YCM4rn8_qRRqChsqhDL2Gg"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <TbBrandSlack class="w-3 h-3" />
            Slack
          </a>
          <span>|</span>
          <a
            href="https://discord.gg/3vmkttmddy"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <TbBrandDiscord class="w-3 h-3" />
            Discord
          </a>
          <span>|</span>
          <a
            href="https://www.linkedin.com/company/storytell-ai"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <TbBrandLinkedin class="w-3 h-3" />
            LinkedIn
          </a>
          <span>|</span>
          <a
            href="https://x.com/storytell_ai"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <svg class="w-3 h-3" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
          <span>|</span>
          <a
            href="https://www.reddit.com/r/Storytell_ai/"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <TbBrandReddit class="w-3 h-3" />
            Reddit
          </a>
          <span>|</span>
          <a
            href="https://www.youtube.com/@storytell_ai"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <TbBrandYoutube class="w-3 h-3" />
            Youtube
          </a>
          <span>|</span>
          <a
            href="https://www.instagram.com/storytell_ai"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <TbBrandInstagram class="w-3 h-3" />
            Instagram
          </a>
          <span>|</span>
          <a
            href="https://www.facebook.com/storytellai"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <TbBrandFacebook class="w-3 h-3" />
            Facebook
          </a>
          <span>|</span>
          <a
            href="https://tiktok.com/@storytell.ai"
            target="_blank"
            rel="noreferrer"
            class="flex items-center gap-1 hover:text-violet-400 dark:hover:text-violet-400"
          >
            <TbBrandTiktok class="w-3 h-3" />
            TikTok
          </a>
        </div>
      </div>
    </div>
  );
};
